<template>
  <a-spin :spinning="loading">
    <a-row>
      <apexchart height="400px"  type="bar" :options="chartOptions" :series="chartSeries"></apexchart>
    </a-row>
  </a-spin>
</template>

<script>
import utils from '../service/service.js'
import detailHover from "@/components/DetailHover.vue";
import moment from "moment";

export default {
  name: 'ABtestResults',
  components: {
  },
  props: {
    mailing: {}
  },
  mixins:[utils],
  data() {
    return {
      chartOptions: {
        title: {
          text: 'Open Rate A/B asuntos',
        },
        chart: {
          id: 'vuechart-example'
        },
        colors:['#5fad56','#F2C14E','#F78154','#4D9078','#B4436C'],
        legend: {
          show: true,
        },
        tooltip: {
          y:{
            formatter: function(e) {
              return e + '%'
            }
          }
        },
        plotOptions: {
          bar: {
            distributed: true, // this line is mandatory
            horizontal: true,

          },
        },
        xaxis: {
          categories: [],
        },
      },
      chartSeries: [{
        name: 'OpenRate',
        data: []
      }],
      loading: false,
    }
  },
  mounted: function() {
    this.plot();
  },
  methods:{
    plot() {
      this.chartOptions = {
        xaxis: {
          categories: this.mailing.subjectList.map((e)=>{
            return e.subject;
          }),
        }
      }
      this.chartSeries[0] = {
        name: "OpenRate",
        data: this.mailing.subjectList.map((e)=> {
          return Math.round((e.opens / e.deliveries)*100) + "%"
        })
      }
    },
  },
  watch: {
    mailing: function() {
      this.plot();
    }
  }

}
</script>